export type HistoricalYieldObservation = {
  id: string;
  candidate_id: string;
  quantity: number | string;
  quantity_unit: string;
  parameter_key: string;
  review_status: string;
  mapped_composition_id: string | null;
  mapped_work_code: string | null;
  suggested_work_code: string | null;
  composition_version: number | null;
  source_file: string;
  source_year: number | null;
  sheet_name: string | null;
  cell_ref: string | null;
  article_code: string | null;
  original_description: string | null;
  evidence: string | null;
  raw_comment: string | null;
  context_note: string;
};

export type HistoricalYieldSelection = HistoricalYieldObservation & {
  quantity: number;
  selected_at: string;
};

export function selectHistoricalYield(
  observation: HistoricalYieldObservation,
  workCode: string,
): HistoricalYieldSelection {
  if (observation.review_status !== "mapped" || !observation.mapped_composition_id
    || observation.mapped_work_code !== workCode) {
    throw new Error("O rendimento ainda não tem uma ligação revista a esta unidade de obra.");
  }
  const quantity = Number(observation.quantity);
  if (observation.parameter_key !== "reinforcement_kg_m3"
    || observation.quantity_unit.replace("³", "3") !== "kg/m3"
    || !Number.isFinite(quantity) || quantity <= 0) {
    throw new Error("O rendimento tem uma unidade ou quantidade incompatível.");
  }
  return { ...observation, quantity, selected_at: new Date().toISOString() };
}
